// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e45b886","239":"af719848","455":"b1f07bc5"}[chunkId] + ".chunk.js";
};